import { FETCH_FORM_TYPE,FETCH_FORM_TYPE_FAILURE,FETCH_FORM_TYPE_SUCCESS } from '../actions/formtype';

const initialState = {
  formtypes: [],
  loading: true,
  err: null,
  haveData: false
};

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_FORM_TYPE:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false
      };
    case FETCH_FORM_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,   
        haveData: true,     
        formtypes: action.data
      };
    case FETCH_FORM_TYPE_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        formtypes: []
      };
    default:
      return state;
  }
}